import { render, staticRenderFns } from "./DsfrSegmentedControl.vue?vue&type=template&id=4f9afef5&scoped=true&"
import script from "./DsfrSegmentedControl.vue?vue&type=script&lang=js&"
export * from "./DsfrSegmentedControl.vue?vue&type=script&lang=js&"
import style0 from "./DsfrSegmentedControl.vue?vue&type=style&index=0&id=4f9afef5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f9afef5",
  null
  
)

export default component.exports